// role-guard.guard.ts
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { getPath, PathUnit } from '@/app/consts/path.const';
import { RoleEnum } from '@/app/consts/role.const';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardGuard  {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    let requiredRoles = route.data['roles'] as string[];
    
    // if no roles are specified,  default to allowing all roles but forbid empty roles
    if (!requiredRoles || requiredRoles.length === 0) {
      // generate all roles based on RoleEnum
      requiredRoles = Object.values(RoleEnum);
    }

    const hasRequiredRole = this.authService.hasRequiredRole(requiredRoles);

    if (hasRequiredRole) {
      return true;
    } else {
      // User is logged in but lacks required roles
      // const loggedIn = this.authService.checkLoggedIn()
      // Check if the user is at least authenticated (has a token)
      const accounts = this.authService.currentMsalService().instance.getAllAccounts();
      if (accounts.length > 0) {
        // User is logged in but lacks required roles, navigate to 403 page
        return this.router.parseUrl('/' + getPath(PathUnit.Forbidden));
      } else {
        // User is not logged in, can redirect to login page or specific page
        // MSAL's MsalGuard usually handles unauthenticated cases, this can be adjusted as needed
        return this.router.parseUrl('/' + getPath(PathUnit.Unauthorized)); // or redirect to login
      }
    }
  }
}